import React from "react";

import {
  Input,
  Select,
  Space,
  Button,
  Col,
  Row,
  message,
  Dropdown,
  Tag,
  Modal,
  Form,
  Tooltip,
  Checkbox,
  Switch,
  Upload,
} from "antd";
import { Link } from "react-router-dom";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import { baseURL } from "../components/Utility";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import {
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  DownOutlined,
  UploadOutlined,
  DownloadOutlined,
  ShareAltOutlined,
  MailOutlined,
  WhatsAppOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import VehicleStore from "../store/VehicleStore";
import withRouter from "../withRouter";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";

import ListTable from "./ListTable";

import CompanyStore from "../store/CompanyStore";
import AssignVehicleToCompany from "./AssignVehicleToCompany";
import VehicleAdd from "./VehicleAdd";
import VehicleSecureTrackAdd from "./VehicleSecureTrackAdd";
import CertificateAdd from "./CertificateAdd";
import dayjs from "dayjs";

import VehicleListFields from "./Plugins/AddVehicle/VehicleListFields";
import VehicleActionColumnIcons from "./Plugins/AddVehicle/VehicleActionColumnIcons";
import GlobalList from "./Plugins/AddVehicle/GlobalList";

import { a } from "react-spring";

import axios from "axios";

import universalCookies from "universal-cookie";

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    // console.log(val.title?.length)
    // if(val.finalWidth ===70){
    //   val.width =80
    // }else if(val.finalWidth ===100){
    //   val.width =150
    // }

    if (val.title?.length >= 18) {
      val.width = 180;
    } else if (val.title?.length > 15) {
      val.width = 160;
    } else if (val.title?.length > 12) {
      val.width = 130;
    } else if (val.title?.length > 8) {
      val.width = 115;
    } else {
      val.width = 105;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class VehicleList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.user = this.props.getUserData().isadmin;

    this.vehicleStore = new VehicleStore();
    this.companyStore = new CompanyStore(this);
    this.universalCookies = new universalCookies();
    this.selectedCol = [
      {
        key: "18",

        title: context.translate("_FLEET_REPORTS_VEHICLEID_"),
        dataIndex: "vehicleId",
        fixed: "left",
        render: (val, record) => {
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
                this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        key: "1",
        title: context.translate("_ASSET_NAME_"),

        dataIndex: "vehicleName",

        style: { fontSize: "12px" },
      },
      config.project != "securetrack"
        ? {
            key: "19",

            title: context.translate("ARABIC_VEHICLE_NO_"),
            dataIndex: "vehicleNoArabic",
          }
        : {
            key: "19",

            title: context.translate("_CHASSIS_NUMBER_"),
            dataIndex: "chassisNo",
          },

      {
        key: "2",

        title: context.translate("_ASSET_NUMBER_"),
        dataIndex: "vehicleNo",
        style: { fontSize: "12px" },
      },

      {
        key: "5",

        title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "companyName",
      },
      {
        key: "6",
        // title: "Driver",
        title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
        dataIndex: "dname",
        finalWidth: 70,
      },
      {
        key: "7",
        // title: "Device",
        title: context.translate("_FLEET_GROUP_GROUPLIST_DEVICENAME_"),
        dataIndex: "deviceName",
        finalWidth: 70,
      },
      {
        key: "8",
        // title: "IMEI",
        title: context.translate("_FLEET_DASHBORD_SETTING_IMEI_"),
        dataIndex: "full_imei",
        style: { fontSize: "12px" },
        finalWidth: 100,
      },
      {
        key: "9",

        title: context.translate("_SIM_NUMBER_"),
        dataIndex: "simNo",
        style: { fontSize: "12px" },
      },
      {
        key: "trackerId",
        title: context.translate("_TRACKER_ID_"),
        dataIndex: "trackerId",
        width: "15%",
      },
      {
        key: "10",

        title: context.translate("_INSTALLATION_DATE_"),
        dataIndex: "installDate",

        style: { fontSize: "12px" },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "11",

        title: context.translate("_EXPIRY_DATE_"),
        dataIndex: "expiryDate",
        style: { fontSize: "12px" },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "20",

        title: context.translate("_INSURANCE_TYPE_"),
        dataIndex: "insuranceRenewal",
        style: { fontSize: "12px" },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        key: "21",

        title: context.translate("_MULKIYA_TYPE_"),
        dataIndex: "mulkiyaRenewal",
        style: { fontSize: "12px" },
        render: (value) => {
          if (value) {
            const formattedDate = dayjs(value).format("DD-MM-YYYY");
            return <>{formattedDate}</>;
          } else {
            return <></>;
          }
        },
      },

      {
        key: "16",
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status2",
        style: { fontSize: "12px" },

        render: (mainValue) => {
          let value = Number(mainValue);
          if (value === 3) {
            return (
              <Tag
                style={{ width: "60px", textAlign: "center" }}
                color={config.deleteColor}
              >
                {/* Expired */}
                {context.translate("_EXPIRED_")}
              </Tag>
            );
          } else if (value === 4) {
            return (
              <Tag
                style={{
                  width: "75px",
                  textAlign: "center",
                  fontSize: "10px",
                }}
                color={config.ExpirySoonColor}
              >
                {/* Expiring Soon */}
                {context.translate("_EXPIRINGSOON_")}
              </Tag>
            );
          } else if (value == 1) {
            return (
              <Tag
                style={{ width: "60px", textAlign: "center" }}
                color={config.activeColor}
              >
                {/* Active */}
                {context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_")}
              </Tag>
            );
          } else if (value == 2) {
            return (
              <Tag
                style={{ width: "74px", textAlign: "center" }}
                color={config.inActiveColor}
              >
                {/* Uninstalled */}
                {context.translate("_UNINSTALLED_")}
              </Tag>
            );
          } else if (value == 5) {
            return (
              <Tag
                style={{ width: "60px", textAlign: "center" }}
                color={config.inActiveColor}
              >
                {/* Deleted */}
                {context.translate("_DELETED_")}
              </Tag>
            );
          } else if (value == 0) {
            return (
              <Tag
                style={{ width: "60px", textAlign: "center" }}
                color={config.inActiveColor}
              >
                Inactive
              </Tag>
            );
          }
          // else if (value == 2) {
          //   return <Tag color="red">Inactive</Tag>;
          // }
        },
      },
      {
        key: "17",

        title: context.translate("_ACTION_"),
        dataIndex: "Action",

        style: { fontSize: "12px" },

        render: (_, record) => {
          // console.log(_, record);
          if (
            Number(record.status2) === 3 ||
            Number(record.status2) === 1 ||
            Number(record.status2) === 2 ||
            Number(record.status2) === 4 ||
            Number(record.status) === 0
          ) {
            return (
              <>
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  (Number(this.props.getUserData().isadmin) === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Space>
                    {/* <VehicleActionColumnIcons
                      vehicleStore={this.vehicleStore}
                      openSharemodal={(record)=>this.handleSharemodal(record.vehicleId)}
                      vehicleId={record.vehicleId}
                    /> */}

                    {config.project === "drive7" && (
                      <>
                        <Tooltip
                          title="Download Certificate"
                          color={config.activeColor}
                        >
                          <DownloadOutlined
                            onClick={() => {
                              this.vehicleStore.downloadCertificate(
                                record.vehicleId
                              );
                            }}
                          />
                        </Tooltip>

                        <Tooltip
                          title="Share Certificate"
                          color={config.activeColor}
                        >
                          <ShareAltOutlined
                            onClick={() => {
                              this.handleSharemodal(record.vehicleId);
                            }}
                          />
                        </Tooltip>
                      </>
                    )}
                    {config.project === "securetrack" &&
                      (record.isRenewed == null || record.isRenewed == 0) && (
                        <>
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              // this.setState({editType: "generate"});
                              this.GenerateCertificate(record.vehicleId);
                            }}
                            //disabled={record.invoice?true:false}
                          >
                            <Tooltip
                              // title="Delete Account"
                              title={this.context.translate(
                                "_GENERATE_CERTIFICATE_"
                              )}
                              placement="bottom"
                              //color={config.tooltipColorDelete}
                            >
                              <span>
                                <i
                                  class="bi bi-arrow-right-square"
                                  style={{ fontSize: "12px" }}
                                ></i>
                              </span>
                            </Tooltip>
                          </Link>

                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              // this.setState({editType: "generate"});
                              this.onTehcnicianData(record.vehicleId);
                            }}
                            //disabled={record.invoice?true:false}
                          >
                            <Tooltip
                              // title="Delete Account"
                              title={this.context.translate(
                                "_TEHCNICIAN_DATA_"
                              )}
                              placement="bottom"
                              //color={config.tooltipColorDelete}
                            >
                              <span>
                                <i
                                  class="bi bi-ev-front-fill"
                                  style={{ fontSize: "12px" }}
                                ></i>
                              </span>
                            </Tooltip>
                          </Link>
                        </>
                      )}
                    {config.project === "securetrack" &&
                      record.isRenewed == 1 && (
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            // this.setState({editType: "generate"});
                            this.downloadCertificate(record);
                          }}
                          //disabled={record.invoice?true:false}
                        >
                          <Tooltip
                            // title="Delete Account"
                            title={this.context.translate(
                              "_DOWNLOAD_CERTIFICATE_"
                            )}
                            placement="bottom"
                            //color={config.tooltipColorDelete}
                          >
                            <span>
                              <i
                                class="bi bi-arrow-down-circle-fill"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </span>
                          </Tooltip>
                        </Link>
                      )}
                    <DeleteConfirm
                      onConfirm={(e) => {
                        e.preventDefault();
                        this.onDelete(record);
                      }}
                    >
                      <Link>
                        <Tooltip
                          // title="Delete Asset"
                          title={this.context.translate(
                            "_FLEET_VEHICLE_VEHICLELIST_DELETE_"
                          )}
                          placement="bottom"
                          color={config.tooltipColorDelete}
                        >
                          <DeleteFilled style={{ color: config.deleteColor }} />
                        </Tooltip>
                      </Link>
                    </DeleteConfirm>

                    <Tooltip
                      title={
                        record.status == "1"
                          ? this.context.translate("_ACTIVE_")
                          : this.context.translate(
                              "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                            )
                      }
                      placement="top"
                      color={
                        record.status == "1"
                          ? config.activeColor
                          : config.inActiveColor
                      }
                    >
                      <Switch
                        size="small"
                        className="form-offlineAlerts"
                        checked={Number(record.status)}
                        onChange={async (val) => {
                          this.setState({ vehicleId: record.vehicleId });
                          this.setState({ isActive: val });
                          this.setState({ showStatusConfirm: true }); // open modal
                        }}
                        // defaultChecked
                      />
                    </Tooltip>
                  </Space>
                )}
              </>
            );
          }
        },
      },
    ];

    //check which user-------
    let column = this.selectedCol;
    if (this.user === -1 || this.user === 3) {
      column = this.selectedCol;
    } else {
      column = this.selectedCol?.filter((val) => val.dataIndex !== "Action");
    }
    this.selectedCol = column;
    // ------------------------------

    let hideColumns = this.selectedCol;
    if (
      config.project === "awtltrack" ||
      config.project === "starlingeye" ||
      config.project === "trackeazy"
    ) {
      hideColumns = this.selectedCol?.filter(
        (val) => val.dataIndex !== "trackerId"
      );
    }
    this.selectedCol = hideColumns;

    this.state = {
      status: 0,
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyLoading: false,
      renewVehicle: false,
      selectedVehicle: "",
      loadData: 0,
      showDeleteModal: false,
      companyVal_Lab: "",
      full_imei: "",
      // selectedVehicle1:false
      selectedRowKeys: [],
      openAssignForm: false,
      openVehicleAddForm: false,
      vehicleIdForEdit: "",
      showAlertModal: false,
      modalVisible: false,
      companyId: "",
      searchField: "",
      showStatusConfirm: false,
      selectedColumns: widthAdderFunc(this.selectedCol),
      isAllVehicle: false,
      showUpload: false,
      excelFile: "",
      excelCompanyId: "",
      openShareModal: false,
      vehicleId: "",
      openCertificateForm: false,
      certificateVehicleId: "",
      listDataUpdate: false,
      creditcertificateType: "",
      certificateType: "",
      showAllCompany: config.project === "securetrack" ? 1 : 1,
      token: "",
      showUploadInfo: false,
      duplicateVehicles: [],
      duplicateImei: [],
      importedVehicles: [],
      // position:[]
    };

    // this.formRef = React.createRef();

    this.waslMenuProps = {
      items: [
        {
          label: (
            <Link to={"/waslvehiclelist"}>
              {" "}
              <PlusOutlined style={{ marginRight: "5px" }} />
              {/* WASL */}
              {context.translate("_WASL_")}
            </Link>
          ),
          key: "1",
        },
        {
          label: (
            <Link to={"/wasltrip"}>
              {" "}
              <PlusOutlined style={{ marginRight: "5px" }} />
              {/* WASL Trip */}
              {context.translate("_WASL_TRIP_")}
            </Link>
          ),
          key: "2",
        },
      ],
      onClick: () => {},
    };

    this.newColumns = widthAdderFunc([
      ...this.state.selectedColumns,
      {
        title: context.translate("_CREATE_DATE"),
        dataIndex: "createdate",
        key: "createdate",
      },
      {
        title: context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_"),
        dataIndex: "serviceexpire",

        key: "serviceexpire",
      },
      {
        title: context.translate("_DEPARTMENT_"),
        dataIndex: "department",
        key: "department",
      },
      {
        title: context.translate("_AREA_"),
        dataIndex: "area",
        key: "area",
      },
      {
        // title: "Installation Type",
        title: context.translate("_RESPONSIBLE_MANAGER"),
        dataIndex: "responsibleManager",
        key: "responsibleManager",
      },
      {
        title: context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_MODEL_"),
        dataIndex: "model",
        key: "model",
      },
      {
        title: context.translate("_VEHICLE_OWNERSHIP_"),
        dataIndex: "ownership",
        key: "ownership",
      },
      {
        title: context.translate("_CONTACT_NO_"),
        dataIndex: "contactNo",
        key: "contactNo",
      },
      {
        title: context.translate("_EMAIL_"),
        dataIndex: "email",
        key: "email",
      },
      {
        title: context.translate("_ORDER_NO_"),
        dataIndex: "orderNo",
        key: "orderNo",
      },
      {
        title: context.translate("_CC_GROUPNO_"),
        dataIndex: "groupNo",
        key: "groupNo",
      },
      // {
      //   title: context.translate("_MONTHLY_LIMIT_"),
      //   dataIndex: "monthlyLimit",
      //   key: "monthlyLimit",
      // },
    ]);

    if (config.project !== "starlingeye") {
      this.newColumns = this.newColumns?.filter(
        (val) => val.dataIndex !== "orderNo" && val.dataIndex !== "groupNo"
        // &&
        // val.dataIndex !== "monthlyLimit"
      );
    }
  }

  handleCheckboxChange = async (column) => {
    // console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      // console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      // console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleSharemodal = (vehicleId) => {
    this.setState({
      openShareModal: true,
      vehicleId: vehicleId,
    });
  };

  downloadCertificate = (response) => {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=vehicleCertificatePdf&cid=" +
      response.companyId +
      "&vid=" +
      response.vehicleId +
      "&IMEI=" +
      response.full_imei +
      "&vno=" +
      response.vehicleNo +
      "&chassisNo=" +
      response.chassisNo +
      "&serviceDate=" +
      response.serviceDate +
      "&expiryDate=" +
      response.expiryDate;
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().userType) == 9 &&
      config.project === "securetrack"
    ) {
      this.props.navigate("/technicianvehiclelist");
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setVehicleStates = this.context.viewStateStore.vehicleDetailsObject;
      // console.log(setVehicleStates);
      if (setVehicleStates.companyId !== "") {
        await this.vehicleStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          // searchField: setVehicleStates.searchText,
          companyId: setVehicleStates.companyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,

          usercompanyId: this.props.getUserData().userCompanyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setVehicleStates.companyId
        );

        await this.setState({ loadList: 1 });
        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    let tokendata = this.universalCookies.get("data")
      ? JSON.parse(base64_decode(this.universalCookies.get("data")))
      : "";
    const userToken = tokendata.userToken;

    this.setState({ token: userToken });
    if (config.project === "securetrack" || config.project === "starlingeye") {
      await this.handleSearch();

      await this.setState({ loadData: 1 });
    }
    if (this.props.params.status === "4") {
      await this.setState({ status: 4 });
    } else if (this.props.params.status == "7") {
      await this.setState({ status: 7, companyId: -1 });
      await this.handleSearch();
    } else {
      if (this.props.params.status) {
        const stat = this.props.params.status.split("_");
        await this.setState({
          status: Number(stat[0]),
          companyId: -1,
          certificateType: stat[1],
        });
        await this.handleSearch();
      }
    }
    //  console.log(this.props.getUserData().userType);

    //  console.log(this.props.params.filter)
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        excelCompanyId: this.props.getUserData().userCompanyId,
      });

      //  console.log(this.state.companyId)
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    await this.setState({ column: this.state.selectedColumns });

    this.setState({ pageSize: 50 });
  }
  async handleChange(comp) {
    if (comp) {
      await this.setState({
        companyId: comp.value,
        currentPage: 1,
        pageSize: 50,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        comp.value,
        1
      );
      // console.log(singleData, comp.value);
      await this.setState({
        companyVal_Lab: singleData,
        companyId: comp.value,
      });
      this.vehicleStore.vehicles = [];
      this.vehicleStore.total = 0;
      this.setState({ loadData: 1 });
      // await this.handleSearch();
    } else {
      // console.log("innn");
      await this.setState({
        companyId: null,
        companyVal_Lab: null,
      });
      this.vehicleStore.vehicles = [];
      this.vehicleStore.total = 0;
      this.setState({ loadData: 1 });
    }
    await this.handleSearch();
  }

  // async handleSearch() {
  //   // this.setState({ loading: true });
  //   await this.vehicleStore.loadData({
  //     offset: (this.state.currentPage - 1) * this.state.pageSize,
  //     limit: this.state.pageSize,
  //     companyId:
  //       config.project === "securetrack"
  //         ? this.props.getUserData().isadmin === 1 ||
  //           this.props.getUserData().isadmin === 0
  //           ? this.props.getUserData().userCompanyId
  //           : -1
  //         : this.state.companyId,
  //     status: this.state.status,
  //     certificateType: this.state.certificateType,
  //     searchField: this.state.searchField,
  //     isadmin: this.props.getUserData().isadmin,
  //     userId: this.props.getUserData().userId,
  //     usercompanyId: this.props.getUserData().userCompanyId,

  //     // usercompanyId: this.props.getUserData().userCompanyId,
  //   });

  //   await this.setState({ loadData: 1 });
  // }

  async handleSearch() {
    const { isadmin, userCompanyId, userId } = this.props.getUserData();
    const {
      currentPage,
      pageSize,
      status,
      certificateType,
      searchField,
      companyId,
    } = this.state;

    let finalCompanyId;

    if (config.project === "securetrack" || config.project === "starlingeye") {
      if (isadmin == 0 || isadmin == 1) {
        finalCompanyId = userCompanyId;
      } else if (isadmin == 3) {
        finalCompanyId = companyId ? companyId : -1;
      } else if (isadmin == -1) {
        finalCompanyId = companyId ? companyId : -1;
      } else {
        finalCompanyId = -1;
      }
    } else {
      finalCompanyId = companyId;
    }

    await this.vehicleStore.loadData({
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      companyId: finalCompanyId,
      status,
      certificateType,
      searchField,
      isadmin,
      userId,
      usercompanyId: userCompanyId,
    });

    this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  onEdit = async (record) => {
    const vehicleId = record.vehicleId;
    if (vehicleId) {
      this.context.viewStateStore.setVehicleStates({
        companyId: record.companyId,
      });
      // this.props.navigate("/vehicleadd/" + vehicleId);
      await this.setState({ vehicleIdForEdit: vehicleId });
      if (this.props.getUserData().userType == 9) {
        await this.setState({ openVehicleSecureTrackAddForm: true });
      } else {
        await this.setState({ openVehicleAddForm: true });
      }
    }
  };

  onTehcnicianData = async (vehicleId) => {
    if (vehicleId) {
      // this.props.navigate("/vehicleadd/" + vehicleId);
      await this.setState({ vehicleIdForEdit: vehicleId });
      await this.setState({ openVehicleSecureTrackAddForm: true });
    }
  };
  GenerateCertificate = async (vehicleId) => {
    // console.log(vehicleId)
    //console.log('innnnnnnnnnnn')
    await this.setState({
      certificateVehicleId: vehicleId,
      openCertificateForm: true,
    });
  };

  async onDelete(record) {
    // console.log(record);
    // console.log(record.vehicleId, "record");
    const response = await this.vehicleStore.deleteRecord({
      vehicleId: record.vehicleId,
      full_imei: record.full_imei,
    });
    // console.log(response);
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (e) => {
    const value = e.target.value;
    // await this.setState({searchField:value})
    if (value.length >= 3) {
      await this.vehicleStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
        status: this.state.status,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ loadList: 1 });
    } else if (value.length === 0) {
      await this.vehicleStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
        status: this.state.status,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ currentPage: 1 });
    }
  };

  async searchInputButton() {
    const isSecureTrack = config.project === "securetrack";
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (isSecureTrack) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.vehicleStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
        status: this.state.status,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ loadData: 1, currentPage: 1 });
    } else if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.vehicleStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
        status: this.state.status,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        usercompanyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ loadData: 1, currentPage: 1 });
    }
  }

  warningRenewVehicle = async () => {
    // await this.setState({selectedVehicle
    //   :true}) ?  await this.setState({renewVehicle:true}) :
    Modal.warning({
      // title: "Alert",
      title: this.context.translate("_FLEET_ALERT_"),
      // content: "Please select vehicles",
      content: this.context.translate("_SELECT_VEHICLES_"),
      style: {
        padding: "20px !important",
        // background: "pink",
        borderRadius: "10px",
        // Add more inline styles as needed
      },
    });
  };

  onRenewVehicleSubmit = async (value) => {
    // console.log(value);
    const data = { ...value, vehicleId: this.state.selectedVehicle };
    // console.log(data);
    const resp = await this.vehicleStore.renewVehicle(data);
    // console.log(resp);
    if (resp.data.success === "S") {
      message.success(resp.data.message);
      // this.setState({selectedRowKeys:[]})
      this.setState({ selectedVehicle: [] });
      // console.log(resp);
    } else {
      message.error(resp.data.message);
    }
    if (resp.data.message) {
      this.setState({ renewVehicle: false });
      this.formRef.current?.resetFields();
    }

    // await this.setState({selectedRowKeys:[]})
    await this.handleSearch();
    await this.setState({ loadData: 1 });
    // console.log(this.state.selectedRowKeys,"dttyftyutyuiyuiuu")
  };

  // warningForDeleteVehicle = async () => {
  //   Modal.warning({
  //     title: "Alert",
  //     content: "Please select vehicles",
  //   });
  // };
  onExcelSubmit = async (fieldsValue) => {
    const data = {
      ...fieldsValue,
      companyId: this.state.excelCompanyId,
      excelFile: this.state.excelFile,
    };
    const resp = await this.vehicleStore.addVehicleByExcel(data);

    if (resp?.success === "S") {
      this.setState({
        showUploadInfo: true,
        duplicateVehicles: resp.data.existingVehicleNos || [],
        duplicateImei: resp.data.existingImeis || [],
        importedVehicles: resp.data.importedVehicles || [],
      });
      // this.formRef.current?.resetFields();
    }
    this.setState({ showUpload: false });
    this.setState({ excelFile: "" });
    this.handleSearch();
    if (resp.message) {
      this.setState({ showUpload: false });
      this.formRef.current?.resetFields();
    }
  };

  getUploadData = async (fileUp) => {
    // console.log(fileUp.file.name)
    let fileinfo = fileUp.file.response;

    // console.log(fileinfo);

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  deleteMultipleVehicles = async (value) => {
    // console.log(value);
    let flag = 0;
    const deleteVehicle = this.state.full_imei.forEach(async (val) => {
      // console.log(val);

      const response = await this.vehicleStore.deleteRecord({
        vehicleId: val.vehicleId,
        full_imei: val.full_imei,
      });
      // console.log(response);
      if (response?.data?.success === "S") {
        if (flag === 0) {
          message.success(response.data.message);
        }

        this.handleSearch();
        flag++;
      } else {
        message.error(response.data.message);
      }
    });
  };

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // console.log(resp.data.message);
      // this.props.navigate("/vehiclelist");
      // console.log(this.state.listDataUpdate);
      await this.setState({ listDataUpdate: true });
      this.setState({
        openVehicleAddForm: false,
        openCertificateForm: false,
        openVehicleSecureTrackAddForm: false,
      });
    } else if (resp.data.success == "F0") {
      if (resp.data.errors[0]?.full_imei) {
        message.error(this.context.translate(resp.data.errors[0]?.full_imei));
      }
    } else {
      message.error(this.context.translate(resp.data.message));
    }
  };

  responseMsg2 = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);

      this.setState({ openCertificateForm: false });
      await this.handleSearch();
    } else {
      message.error(this.context.translate(resp.data.message));
    }
  };

  confirmStatus = async (status) => {
    const data = {};

    data.vehicleId = this.state.vehicleId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.vehicleStore.updateStatus(data);

    // console.log(data);

    this.setState({ showStatusConfirm: false });
    await this.handleSearch();
    //  await this.setState({ loading: true });
    //   await this.driversStore.loadData({ offset: 0, limit: 50 });
    // await this.setState({ loading: false });
  };

  closeModal = () => {
    this.setState({
      openVehicleAddForm: false,
      openVehicleSecureTrackAddForm: false,
    });
    this.setState({ openCertificateForm: false });
  };

  shareToWhatsApp = () => {
    var url =
      config.baseURL +
      "index.php?c=vehicle&a=downloadCertificatePdf&vid=" +
      this.state.vehicleId;

    var url2 = encodeURIComponent(url);
    // console.log(url2);

    window.open("https://wa.me/?text=" + url2);
  };

  shareToEmail = () => {
    window.open("https://www.google.com/gmail/about/");
  };

  handleClear = async () => {
    await this.vehicleStore.loadData({
      offset: 0,
      limit: 50,
      companyId: -1,
      status: this.state.status,
      certificateType: this.state.certificateType,
      searchField: this.state.searchField,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,

      // usercompanyId: this.props.getUserData().userCompanyId,
    });
    await this.setState({ loadData: 1, currentPage: 1, loading: false });
  };

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("fileType", "accountimport");
      formData.append("fieldName", "excelFile");

      const response = await axios.post(
        config.NodeUrl + "/vehicle/uploadExcel",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_VEHICLE_VEHICLELIST_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                {/* <AddButton
                  link="/vehicleadd"
                  title={this.context.translate("_ADD_")}
                /> */}
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  (Number(this.props.getUserData().isadmin) === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Tooltip
                    // title="Add"
                    title={this.context.translate(
                      "_FLEET_ROLE_ROLELIST_ADDBTN_"
                    )}
                    placement="left"
                    color={config.primaryColor}
                  >
                    <Button
                      className="addButton"
                      icon={<PlusOutlined />}
                      type="primary"
                      onClick={() =>
                        this.setState({
                          openVehicleAddForm: true,
                          vehicleIdForEdit: "",
                        })
                      }
                    ></Button>
                  </Tooltip>
                )}

                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3) && (
                  <VehicleListFields menu={this.waslMenuProps} />
                )}

                {(Number(this.props.getUserData().isadmin) === -1 ||
                  (Number(this.props.getUserData().isadmin) === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Button
                    onClick={async (e) => {
                      this.state.selectedVehicle.length > 0
                        ? await this.setState({ renewVehicle: true })
                        : await this.setState({ showAlertModal: true });
                    }}
                  >
                    <i class="bi bi-plus" style={{ marginRight: "5px" }}></i>
                    {/* Renew */}
                    {this.context.translate("_RENEW_")}{" "}
                  </Button>
                )}

                {(Number(this.props.getUserData().isadmin) === -1 ||
                  (Number(this.props.getUserData().isadmin) === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Button
                    onClick={() => this.setState({ openAssignForm: true })}
                  >
                    <span>
                      {" "}
                      <i
                        class="bi bi-car-front"
                        style={{ marginRight: "5px" }}
                      ></i>
                      {/* Assign */}
                      {this.context.translate("_ASSIGN_")}
                    </span>
                  </Button>
                )}
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  (Number(this.props.getUserData().isadmin) === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Button
                    onClick={async () => {
                      this.state.selectedVehicle.length > 0
                        ? await this.setState({ showDeleteModal: true })
                        : await this.setState({ showAlertModal: true });
                    }}
                  >
                    <i class="bi bi-trash3" style={{ marginRight: "5px" }}></i>

                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                    )}
                  </Button>
                )}

                {(this.props.getUserData().isadmin === 1 ||
                  (this.props.getUserData().isadmin === 3 &&
                    Number(this.props.getUserData().userType) != 9)) && (
                  <Tooltip
                    // title="Upload"
                    title={this.context.translate("_UPLOAD_")}
                    color={config.tooltipColorEdit}
                  >
                    <Button
                      type={config.uploadBoxType}
                      onClick={() => this.setState({ showUpload: true })}
                    >
                      <UploadOutlined />
                    </Button>
                  </Tooltip>
                )}

                <GlobalList />

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Button
                  className="exportDropdown"
                  disabled={
                    this.vehicleStore?.vehicles?.length > 0 ? false : true
                  }
                  // style={{ backgroundColor: config.activeColor }}
                  onClick={(val) => {
                    const result = [];
                    this.state.selectedColumns.forEach((obj) => {
                      if (obj.dataIndex === "status2") {
                        result.push("status");
                      } else {
                        result.push(obj.dataIndex);
                      }
                    });
                    // console.log(
                    //   result,
                    //   this.state.selectedVehicle,
                    //   "this.state.selectedVehicle"
                    // );
                    var getData = {
                      cid:
                        this.state.companyId == -1 ? 0 : this.state.companyId,
                      UcompanyId: JSON.parse(base64_decode(Cookies.get("data")))
                        .userCompanyId,
                      isadmin: JSON.parse(base64_decode(Cookies.get("data")))
                        .isadmin,
                      userId: this.props.getUserData().userId,
                      searchField: this.state.searchField,
                      status: this.state.status,
                      vehicleIds: this.state.selectedVehicle,
                      colList: result,
                    };
                    // console.log(getData);
                    if (val) {
                      this.vehicleStore.exportExcel(getData);
                    }
                  }}
                >
                  {" "}
                  <DownloadOutlined />
                  {this.context.translate("_EXPORT_")}
                </Button>

                {/* <Dropdown menu={this.menuProps}>
                  <Button>
                    <Space>
                      {this.context.translate("_ACTION_")}

                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown> */}
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  showAll={this.state.showAllCompany}
                  allowClear={true}
                  onClear={
                    config.project === "securetrack" ||
                    config.project === "starlingeye"
                      ? this.handleClear
                      : undefined
                  }
                  onChange={(value) => this.handleChange(value)}
                  // disabled={this.state.companyLoading}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  // style={{ width: 200 }}
                  style={companyInputBox}
                />

                {/* {(this.props.getUserData().isadmin === 3 ||
                  this.props.getUserData().isadmin === -1) && (
                  <Checkbox
                    checked={this.state.isAllVehicle}
                    onChange={async (e) => {
                      await this.setState({ isAllVehicle: e.target.checked });

                      if (this.state.isAllVehicle) {
                        await this.setState({ companyId: -1 });
                        await this.handleSearch();
                      } else {
                        this.vehicleStore.vehicles = [];
                        this.vehicleStore.total = 0;
                      }
                      await this.setState({ loadData: 1 });
                    }}
                  >
                    All Vehicle
                  </Checkbox>
                )} */}
                <Select
                  style={{ width: 150 }}
                  onSelect={async (value) => {
                    await this.setState({ status: value });

                    await this.searchInputButton();
                  }}
                  value={this.state.status}
                  defaultValue={
                    this.props.params.status === "4" ? 4 : this.state.status
                  }
                  // placeholder="Status"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"
                  )}
                >
                  <Select.Option value={0}>
                    {this.context.translate("_ALL_")}
                  </Select.Option>
                  <Select.Option value={1}>
                    {this.context.translate("_INSTALLED_")}
                  </Select.Option>
                  <Select.Option value={2}>
                    {this.context.translate("_UNINSTALLED_")}
                  </Select.Option>
                  <Select.Option value={3}>
                    {this.context.translate("_EXPIRED_")}
                  </Select.Option>
                  <Select.Option value={4}>
                    {this.context.translate("_EXPIRINGSOON_")}
                  </Select.Option>
                  <Select.Option value={5}>
                    {this.context.translate("_DELETED_")}
                  </Select.Option>
                  <Select.Option value={6}>
                    {this.context.translate("_CERTIFIED_")}
                  </Select.Option>
                  <Select.Option value={7}>
                    {this.context.translate("_NON_CERTIFIED_")}
                  </Select.Option>
                </Select>
                <Select
                  style={{ width: 150 }}
                  onSelect={async (value) => {
                    await this.setState({ certificateType: value });
                    await this.searchInputButton();
                  }}
                  value={this.state.certificateType}
                  // defaultValue={
                  //   this.state.certificateType == "schoolBus" ? "schoolBus" : this.state.certificateType
                  // }
                  // placeholder="Status"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_INFORMATION_TYPE_"
                  )}
                >
                  <Select.Option value="desertSafari">
                    {this.context.translate("_DESERT_SAFARI_")}
                  </Select.Option>
                  <Select.Option value="schoolBus">
                    {this.context.translate("_SCHOOL_BUS_")}
                  </Select.Option>
                  <Select.Option value="rentCar">
                    {this.context.translate("_RENT_CAR_")}
                  </Select.Option>
                  <Select.Option value="otherCategory">
                    {this.context.translate("_OTHER_CATEGORY_")}
                  </Select.Option>
                </Select>
                <Input
                  // placeholder="Search By Brand,Driver Name,Sim No,IMEI,Asset"
                  placeholder={this.context.translate(
                    "_SEARCH_BY_BRAND_DRIVERNAME_SIMNO_IMEI_ASSET_"
                  )}
                  value={this.state.searchField ? this.state.searchField : ""}
                  style={{ width: 420 }}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                    this.searchInput(e);
                  }}
                  // allowClear
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                />
              </Space>
            </Col>
          </Row>

          <ListTable
            rowSelection={{
              // columnWidth: 2,
              fixed: true,
              selectedRowKeys: this.state.selectedVehicle,
              onChange: async (selectedRowKeys, selectedRows) => {
                await this.setState({ selectedVehicle: selectedRowKeys });

                await this.setState({ full_imei: selectedRows });
              },
            }}
            // value={this.state.selectedRowKeys}
            rowKey="vehicleId"
            currentPage={this.state.currentPage}
            total={this.vehicleStore?.total}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            dataSource={this.vehicleStore?.vehicles}
            loading={this.vehicleStore?.loading}
            onChange={this.handleTableChange}
            // scroll={{
            //   x:1800
            // }}
          />

          <Modal
            title={this.context.translate("_RENEW_VEHICLE_")}
            // title="Renew Vehicle"
            open={
              this.state.selectedVehicle.length !== 0 && this.state.renewVehicle
            }
            onOk={() => this.setState({ renewVehicle: false })}
            onCancel={() => this.setState({ renewVehicle: false })}
            footer={false}
            width={400}
          >
            {/* {console.log(this.state.selectedVehicle.length !==0 ,this.state.renewVehicle,"sfgdfg")} */}
            <Form
              name="renewVehicle"
              layout="vertical"
              onFinish={this.onRenewVehicleSubmit}
              style={{ maxWidth: "100%" }}
            >
              <Row>
                <Col span={12}></Col>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                ></Col>
              </Row>

              <Form.Item
                name="renewvalue"
                // label="Renewed For"
                label={this.context.translate("_RENEWAL_FOR_")}
                rules={[{ required: true }]}
              >
                <Select style={{ width: 350 }}>
                  {/* <Select.Option value="11">1 Month</Select.Option>
                  <Select.Option value="12">3 Month</Select.Option>
                  <Select.Option value="13">6 Month</Select.Option> */}
                  <Select.Option value="1">1 Year</Select.Option>
                  <Select.Option value="2">2 Year</Select.Option>
                  <Select.Option value="3">3 Year</Select.Option>
                  <Select.Option value="4">4 Year</Select.Option>
                  <Select.Option value="5">5 Year</Select.Option>
                  <Select.Option value="6">6 Year</Select.Option>
                  <Select.Option value="7">7 Year</Select.Option>
                  <Select.Option value="8">8 Year</Select.Option>
                  <Select.Option value="9">9 Year</Select.Option>
                  <Select.Option value="10">10 Year</Select.Option>
                </Select>
              </Form.Item>
              <div className="formBtnGroup">
                {/* css class */}
                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                  // loading={this.state.loading}
                >
                  {this.context.translate("_SUBMIT_")}
                  {/* css class */}
                  {/* Submit */}
                </Button>{" "}
              </div>

              {/* <Row justify={"end"}>
              <Space style={{ padding: "10px" }}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Space>
              </Row> */}
            </Form>
          </Modal>

          <Modal
            width={350}
            className="alert-model"
            title=<div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-trash3"
              ></i>{" "}
              {/* Remove Asset? */}
              {this.context.translate(
                "_FLEET_VEHICLE_VEHICLELIST_REMOVETITLE_"
              )}
            </div>
            open={
              this.state.selectedVehicle.length !== 0 &&
              this.state.showDeleteModal
            }
            onCancel={() => this.setState({ showDeleteModal: false })}
            footer={[
              <Button
                // key="no"
                onClick={() => this.setState({ showDeleteModal: false })}
              >
                {this.context.translate("_FLEET_RULELIST_CRONRULE_NO_")}
                {/* No */}
              </Button>,
              <Button
                type="primary"
                onClick={(e) => {
                  this.deleteMultipleVehicles();

                  // console.log(this.state.selectedVehicle);
                  this.setState({
                    showDeleteModal: false,
                    selectedVehicle: "",
                  });
                }}
              >
                {this.context.translate("_FLEET_RULEDETAIL_ACTIVEDDL_YES_")}
                {/* Yes */}
              </Button>,
            ]}
          >
            {this.context.translate("_SURE_TO_DELETE_")}
            {/* <p>Are you sure you want to delete?</p> */}
          </Modal>
        </div>

        {this.state.openAssignForm && (
          <Modal
            bodyStyle={{ height: "645px" }}
            className="formShowModal" //  {/* css class */}
            // title="Assign Vehicle To Company"
            title={this.context.translate("_ASSIGN_VEHICLE_TO_COMPANY_")}
            centered
            visible={this.state.openAssignForm}
            footer={null}
            onCancel={() => {
              this.setState({ openAssignForm: false });
            }}
            width={665}
          >
            <div>
              <AssignVehicleToCompany />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Modal>
        )}

        {this.state.openVehicleAddForm && (
          <Modal
            bodyStyle={{ height: "100%" }}
            className="formShowModal" //  {/* css class */}
            // title="Add New Vehicle"
            maskClosable={false}
            title={this.context.translate("_ADD_NEW_VEHICLE_")}
            centered
            visible={this.state.openVehicleAddForm}
            footer={null}
            onCancel={() => {
              this.setState({ openVehicleAddForm: false });
            }}
            width={665}
          >
            <div>
              <VehicleAdd
                vehicleIdForEdit={this.state.vehicleIdForEdit}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Modal>
        )}

        {this.state.openVehicleSecureTrackAddForm && (
          <Modal
            bodyStyle={{ height: "100%" }}
            className="formShowModal" //  {/* css class */}
            // title="Add New Vehicle"
            maskClosable={false}
            title={this.context.translate("_ADD_NEW_VEHICLE_")}
            centered
            visible={this.state.openVehicleSecureTrackAddForm}
            footer={null}
            onCancel={() => {
              this.setState({ openVehicleSecureTrackAddForm: false });
            }}
            width={665}
          >
            <div>
              <VehicleSecureTrackAdd
                vehicleIdForEdit={this.state.vehicleIdForEdit}
                response={this.responseMsg}
                closeModal={this.closeModal}
                fromVehicleList={true}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Modal>
        )}
        {this.state.openCertificateForm && (
          <Modal
            bodyStyle={{ height: "100%" }}
            className="formShowModal" //  {/* css class */}
            // title="Add New Vehicle"
            maskClosable={false}
            title={this.context.translate("_VEHICLE_CERTIFICATE_")}
            centered
            visible={this.state.openCertificateForm}
            footer={null}
            onCancel={() => {
              this.setState({ openCertificateForm: false });
            }}
            width={665}
          >
            <div>
              <CertificateAdd
                response={this.responseMsg2}
                closeModal={this.closeModal}
                certificateVehicleId={this.state.certificateVehicleId}
              />
              {/* companyId={this.state.companyId} ID={this.state.assignId} response={this.assignresponseMsg} */}
            </div>
          </Modal>
        )}
        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>

        {this.state.showUpload && (
          <>
            {" "}
            <Modal
              open={this.state.showUpload}
              // title="File Upload"
              title={this.context.translate("_FILE_UPLOAD_")}
              maskClosable={false}
              onOk={() => this.setState({ showUpload: false })}
              onCancel={() =>
                this.setState({
                  showUpload: false,
                  excelFile: "",
                  companyId: "",
                })
              }
              footer={false}
              width={400}
              // style={{width:100}}
            >
              <Form
                name="excelimport"
                layout="vertical"
                onFinish={this.onExcelSubmit}
                style={{ padding: "0px 10px" }}
              >
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    label={this.context.translate("_ACCOUNT_")}
                    rules={[{ required: true }]}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        // console.log(companyId.value);
                        this.setState({ excelCompanyId: companyId.value });
                        // this.formRef.current.setFieldsValues({excelFile:undefined})
                      }}
                      style={{ width: 300 }}
                    />
                  </Form.Item>
                )}

                <Form.Item
                  name="excelFile"
                  // className="label-seprator"

                  className="uploadFile"
                  // label="Excel File"
                  label={this.context.translate("_EXCEL_FILE_")}
                  rules={[{ required: true }]}
                >
                  <Upload
                    onRemove={() =>
                      this.setState({ excelFile: "", fileList: [] })
                    }
                    name="excelFile"
                    customRequest={(options) => this.uploadFunction(options)}
                    listType="text"
                    data={{
                      fileType: "accountimport",
                      fieldName: "excelFile",
                    }}
                    onChange={this.getUploadData}
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>
                      {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                    </Button>
                  </Upload>
                </Form.Item>

                <div className="formBtnGroup">
                  <Button
                    className="formCancelButton"
                    // style={{ backgroundColor: config.activeColor }}
                    onClick={() => this.vehicleStore.sampleExcel()}
                  >
                    {this.context.translate("_SAMPLE_")}
                  </Button>
                  <Button
                    type="primary"
                    className="formSaveButton"
                    htmlType="submit"
                    // loading={this.state.loading}
                  >
                    {this.context.translate("_UPLOAD_")}
                  </Button>
                </div>
              </Form>
            </Modal>{" "}
          </>
        )}

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={this.context.translate("_CONFIRM_")}
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            //footer={null}
            onOk={this.confirmStatus}
            onCancel={() => {
              this.setState({ showStatusConfirm: false });
            }}
            width={400}
          >
            {this.state.isActive === true ? (
              <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
            ) : (
              <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
            )}
          </Modal>
        )}

        {/* title: "Alert",
      content: "Please select vehicles", */}
        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showAlertModal}
          onOk={() => this.setState({ showAlertModal: false })}
          onCancel={() => this.setState({ showAlertModal: false })}
          okText="OK"
          cancelText="Cancel"
          footer={[
            <Button
              type="primary"
              onClick={() => this.setState({ showAlertModal: false })}
            >
              {/* OK */}
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>,
          ]}
        >
          {/* <p>Please select vehicles</p> */}
          {this.context.translate("_SELECT_VEHICLES_")}
        </Modal>

        <Modal
          maskClosable={false}
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "600",
              }}
            >
              <span>{this.context.translate("_CONFIRM_")}</span>
              <CloseOutlined
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={() => this.setState({ showUploadInfo: false })}
              />
            </div>
          }
          className=""
          description="Are you sure to change this status?"
          centered
          open={this.state.showUploadInfo}
          footer={null}
          width={500}
          closable={false}
        >
          {this.state.duplicateVehicles.length > 0 && (
            <>
              <p>
                These vehicles already exist and were not imported (
                {this.state.duplicateVehicles.join(", ")})
              </p>
            </>
          )}

          {this.state.duplicateImei.length > 0 && (
            <>
              <p>
                These Imei already exist and were not imported(
                {this.state.duplicateImei.join(", ")})
              </p>
            </>
          )}

          {this.state.importedVehicles.length > 0 && (
            <>
              <p>
                These vehicles were imported sucessfully:(
                {this.state.importedVehicles.join(", ")})
              </p>
            </>
          )}

          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Button
              type="primary"
              className="confirmStatusOkButton"
              onClick={() => this.setState({ showUploadInfo: false })}
            >
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>
          </div>
        </Modal>

        {this.state.openShareModal && (
          <Modal
            // title="SHARE"
            title={this.context.translate("_FLEET_SERVICE_POILIST_SHARE_")}
            open={this.state.openShareModal}
            onCancel={() => this.setState({ openShareModal: false })}
            footer={null}
            maskClosable={false}
            width={200}
            style={{
              top: 10,
              right: "30px",
            }}
            centered
          >
            <div style={{ display: "inline-grid", gap: "9px" }}>
              <Tag
                icon={<MailOutlined />}
                color="#cd201f"
                onClick={this.shareToEmail}
              >
                Email
              </Tag>

              <Tag
                icon={<WhatsAppOutlined />}
                color="teal"
                onClick={this.shareToWhatsApp}
              >
                WhatsApp
              </Tag>

              <h6 style={{ margin: "0px" }}>
                {this.context.translate("_LINK_TO_SHARE_")}
              </h6>
              <Input
                style={{ height: "36px" }}
                value={`https://www.drive7gps.com/app/index.php?c=vehicle&a=downloadCertificatePdf&vid=${this.state.vehicleId}`}
                // value={`https://www.google.com/maps?q=${this.props.shareSingleLocation}`}
              />
            </div>
          </Modal>
        )}
      </>
    );
  }
}
VehicleList.contextType = StoreContext;
export default observer(withRouter(VehicleList));
